<template>
  <div class="key-code-page">
    <!-- 类型 0 保留原授权二维码流程；类型 1 展示服务员代客绑定并确认商品的页面。 -->
    <div class="key-code-content" v-if="KeyBindComponentCallType === 0">
      <div class="page-head">
        <h1>{{ pageTitle }}</h1>
        <p>{{ pageTips }}</p>
      </div>

      <div class="step-bar" :class="`step-current-${currentStep}`">
        <div class="step-line">
          <span class="line-progress"></span>
          <span
            class="line-dot"
            v-if="currentStep < 2"
          ></span>
          <span
            class="line-dot line-dot-right"
            :class="{ active: currentStep === 2 }"
            v-if="currentStep < 3"
          ></span>
        </div>
        <div
          class="step-item"
          v-for="item in steps"
          :key="item.value"
          :class="{ active: currentStep >= item.value }"
        >
          <i>{{ item.value }}</i>
          <span>{{ item.label }}</span>
        </div>
      </div>

      <div class="form-state" v-if="pageStatus === 'input'">
        <div class="section-title">填写信息</div>
        <input
          v-model.trim="handCode"
          class="hand-input"
          type="text"
          maxlength="20"
          placeholder="请输入手牌号"
        />
      </div>

      <div class="qr-state" v-if="pageStatus === 'qrcode'">
        <div class="qr-box">
          <vue-qr :text="qrCodeText" :size="210" :margin="0"></vue-qr>
        </div>
        <p class="qr-desc">请顾客使用微信扫描授权二维码并绑定手牌</p>
        <p class="expire-tips">{{ countDown }}秒后授权二维码将失效</p>
      </div>

      <div class="success-state" v-if="pageStatus === 'success'">
        <div class="success-icon">
          <i></i>
        </div>
        <p class="success-subtitle">恭喜您</p>
        <p class="success-title">{{ handCode }}已绑定成功</p>
      </div>
    </div>

    <button
      v-if="KeyBindComponentCallType === 0 && pageStatus !== 'success'"
      class="bottom-btn"
      :class="{ disabled: loading }"
      :disabled="loading"
      @click="handleBottomClick"
    >
      {{ bottomText }}
    </button>

    <div class="waiter-order" v-if="KeyBindComponentCallType === 1">
      <div class="waiter-head">
        <strong>授权绑定手牌</strong>
        <span>（输入顾客手牌号，下单）</span>
      </div>

      <section class="waiter-section bind-section">
        <h2>填写信息</h2>
        <div class="bind-row">
          <input
            v-model.trim="handCode"
            type="text"
            maxlength="20"
            placeholder="请输入手牌号"
          />
          <button type="button" @click="scanHandCode">扫手牌码</button>
        </div>
      </section>

      <section class="waiter-section goods-section">
        <h2>商品名称</h2>
        <div class="goods-table-head">
          <span>商品名称</span><span>单价</span><span>数量</span><span>删除</span>
        </div>
        <div class="goods-row" v-for="(item, index) in orderGoods" :key="item.Id || item.ProductId || index">
          <span class="goods-name" :title="item.ProductName">{{ item.ProductName }}</span>
          <span>{{ formatPrice(item.Price) }}</span>
          <div class="quantity-control">
            <button type="button" :disabled="item.Quantity <= 1" @click="changeQuantity(index, -1)">−</button>
            <span>{{ item.Quantity }}</span>
            <button type="button" :disabled="orderStatus!==88" @click="changeQuantity(index, 1)">＋</button>
          </div>
          <button class="delete-btn" type="button" aria-label="删除"  :disabled="orderStatus!==88" @click="removeGoods(index)">
            <i></i>
          </button>
        </div>
        <div class="goods-empty" v-if="!orderLoading && orderGoods.length === 0">暂无商品</div>
      </section>

      <section class="waiter-section remark-section">
        <h2>商品可选备注(点击选择)</h2>
        <div class="quick-remarks">
          <button
            v-for="item in quickRemarkList"
            :key="item"
            type="button"
            :class="{ selected: selectedRemarks.includes(item) }"
            @click="toggleRemark(item)"
          >{{ item }}</button>
        </div>
        <textarea
          v-model="orderRemark"
          maxlength="100"
          placeholder="其他需求，可以在此处给商家留言哦"
        ></textarea>
        <span class="remark-count">{{ orderRemark.length }}/100</span>
      </section>

      <div class="waiter-status"  v-if="orderStatus===88"   @click="handleSubmitGoodsClick" >提交消费</div>
      <div class="waiter-status-other"  v-else-if="orderStatus===1" >当前订单已处理</div>
      <div class="waiter-status-other"  v-else-if="orderStatus===2" >当前订单已超时</div>
    </div>
  </div>
</template>

<script>
import { getQrcode, isbindinginfo } from "@/api/scan";
import { getGoodOrderDetail, getOrderDetail } from "@/api/order";
import { handleScanCode, handleSessionStorage } from "@/utils";
import { submitFoodOrder } from "@/api/foodOrder";

export default {
  name: "KeyCodeQRCreate",
  data() {
    return {
      KeyBindComponentCallType:0, //呼叫目的
      pageStatus: "input",
      handCode: "",
      qrCodeText: "",
      countDown: 60,
      loading: false,
      timer: null,
      pollTimer: null,
      vpnInfo:{},
      OrderId:0,
      orderGoods: [],
      orderLoading: false,
      dinidnRoomInfo:{},
      quickRemarkList: [],
      selectedRemarks: [],
      orderRemark: "",
      isSubmitFoodOrder:false ,
      orderStatus:0, //订单状态，只有当丁宁单状态为0的才可以提交，其他状态的不能提交 
      steps: [
        { value: 1, label: "生成授权" },
        { value: 2, label: "顾客识别" },
        { value: 3, label: "授权成功" },
      ],
    };
  },
  computed: {
    currentStep() {
      const stepMap = {
        input: 1,
        qrcode: 2,
        success: 3,
      };
      return stepMap[this.pageStatus];
    },
    pageTitle() {
      if (this.pageStatus === "qrcode") {
        return `手牌号：${this.handCode}`;
      }
      if (this.pageStatus === "success") {
        return "授权结果";
      }
      return "授权绑定手牌";
    },
    pageTips() {
      if (this.pageStatus === "qrcode") {
        return "请向顾客出示二维码，60秒内完成绑定！";
      }
      if (this.pageStatus === "success") {
        return "恭喜你，已帮助顾客完成手牌绑定！";
      }
      return "输入顾客手牌号，点击“生成授权二维码”！";
    },
    bottomText() {
      return this.pageStatus === "qrcode"
        ? "重新生成授权二维码"
        : "生成授权二维码";
    },
    canSubmit() {
      return Boolean(this.handCode);
    },
  },
  created() {
        const query = this.$route.query || {};
        this.OrderId = query.OrderId||0;
        const params = this.$route.params;
        if(this.OrderId==undefined||this.OrderId==null||this.OrderId==0){
          this.OrderId = params.OrderId||0;
        }
       const preStoreInfo = localStorage.getItem("store");
       if(preStoreInfo){
         this.vpnInfo = JSON.parse(preStoreInfo)
       }
    this.dinidnRoomInfo = handleSessionStorage.get("diningRoomInfo");
    if (this.dinidnRoomInfo && this.dinidnRoomInfo.Remark) {
      this.quickRemarkList = this.dinidnRoomInfo.Remark.split(",");
    }
  
    console.log("vpnInfo===== "+JSON.stringify(this.vpnInfo))
     this.KeyBindComponentCallType = this.vpnInfo.vpnInfo.WaiterCallPurpose||0
    // console.log("KeyBindComponentCallType===== "+this.KeyBindComponentCallType)
    // console.log("this.OrderIdthis.OrderId===== "+this.OrderId)

      if (this.KeyBindComponentCallType === 1) {
         this.loadOrderGoods();
    }
    if (query.handCode || query.keyCode || query.tableCode) {
      this.handCode = query.handCode || query.keyCode || query.tableCode;
    }
    if (query.status === "success" || query.bindStatus === "success") {
      this.pageStatus = "success";
    }
  },
  beforeDestroy() {
    this.clearTimers();
  },
  methods: {
    // 根据呼叫消息携带的订单号加载商品，兼容接口返回 Items 数组或单个订单对象。
    loadOrderGoods() {
      if (!this.OrderId) return;
      this.orderLoading = true;
      getGoodOrderDetail({id: this.OrderId })
        .then((res) => {
            // console.log("getGoodOrderDetail===== "+JSON.stringify(res))
            //  console.log("getGoodOrderDetail===== "+res.Status)
          this.orderStatus = res.Status
          const order = res && Array.isArray(res.Items) ? res.Items[0] : res;
          const details = order && Array.isArray(order.Details) ? order.Details : [];
          this.orderGoods = details.map((item) => ({
            ...item,
            ProductName: item.ProductName || item.GoodsName || "未命名商品",
            Price: item.Price != null ? item.Price : (item.SettlePrice || item.PresentPrice || 0),
            Quantity: Number(item.Quantity || item.GoodsNum || item.NumberCount || 1),
          }));
          if (order && order.Remark) this.orderRemark = order.Remark;
        })
        .catch(() => {
          this.$toast("订单商品加载失败");
        })
        .finally(() => {
          this.orderLoading = false;
        });
    },
    // 调起微信扫一扫，并从常见手牌二维码格式中提取手牌号回填。
    scanHandCode() {
        // 调起微信扫码，
      handleScanCode({ needResult: 1 }, (res) => {
        const cardCodeData = res.resultStr;
        if (!cardCodeData) {
          this.$toast("二维码为空，请确认后重新扫码");
          return;
        }
        
        this.handCode = cardCodeData;
      // var vpncodeQuery ="" 
      // var uuidQuery = ""
      // const pageQueryArr = cardCodeData.split("?M=");
      // if(pageQueryArr instanceof Array && pageQueryArr.length==2){
      //  const orgString = pageQueryArr[1];
      //   const arr = orgString.split('@');
      //   if(arr instanceof Array && arr.length==2){
      //      uuidQuery = arr[0],
      //      vpncodeQuery = arr[1]
      //   } 
      // }
      //   console.log("pageQuery 数据加载中 ==== "+uuidQuery)
      //   console.log("pageQuery  门店参数code  ==== "+vpncodeQuery)
      //   //  this.$toast("扫码拿到的数据："+uuidQuery+"vpncodeQuery"+vpncodeQuery);
      //   if ((!uuidQuery || !vpncodeQuery)) {
      //     this.$toast("二维码缺少必要参数，请确认后重新扫码");
      //     return;
      //   }
      //   let queryData = {
      //     IsBind: true,
      //     BindingUuid:uuidQuery,
      //     VpnCode:vpncodeQuery
      //   };
      //   getScanTakeNumber(queryData)
      //     .then((res) => {
      //       this.handCode = res.TableCode;
      //     })
      //     .catch((err) => {
      //       this.$toast("绑定手牌失败："+err)
      //     });
      });
    },
 
    // 商品数量只在当前确认页内调整，最小数量为 1。
    changeQuantity(index, step) {
      if(this.orderStatus!==88){
           this.$toast("订单已提交不可再操作");
        return
      }
      const item = this.orderGoods[index];
      if (!item) return;
      this.$set(item, "Quantity", Math.max(1, Number(item.Quantity) + step));
    },
    // 删除前二次确认，防止误触；确认后从当前商品列表移除。
    removeGoods(index) {
        if(this.orderStatus!==88){
           this.$toast("订单已提交不可再操作");
        return
      }
      const item = this.orderGoods[index];
      if (!item) return;
      this.$dialog.confirm({ title: "提示", message: `确认删除“${item.ProductName}”吗？` })
        .then(() => this.orderGoods.splice(index, 1))
        .catch(() => {});
    },
    // 快捷备注支持多选，再次点击即可取消。
    toggleRemark(remark) {
      if(this.orderStatus!==88){
         this.$toast("订单已提交不可再操作");
        return
      }
      const index = this.selectedRemarks.indexOf(remark);
      if (index > -1) this.selectedRemarks.splice(index, 1);
      else this.selectedRemarks.push(remark);
    },
    formatPrice(price) {
      const value = Number(price);
      return Number.isFinite(value) ? value.toFixed(2).replace(/\.00$/, "") : "0";
    },

    /***提交订单*/
    handleSubmitGoodsClick(){
        if(!this.handCode){
           this.$toast("手牌不能为空");
          return
        }

        if(this.handCode==""){
          this.$toast("手牌不能为空");
          return
        }

        if(!this.orderGoods){
          this.$toast("消费不能为空");
          return
        }

        if(this.orderGoods.length==0){
          this.$toast("消费不能为空");
          return
        }

        if(this.isSubmitFoodOrder === true){
           this.$toast("请不要重复提交订单，正在提交中……");
          return
        }
      this.isSubmitFoodOrder = true
       this.$toast("提交中，请稍后……");
       const requestData = {
        OrderId:this.OrderId||null,
        VpnId: this.vpnInfo.vpnId,
        KeyCode: this.handCode,
        Remark:(this.orderRemark ? this.orderRemark + "；" : "") + this.selectedRemarks.join(),
        Items: this.orderGoods,
        IsOrderByWaiter:true,
        PayType:2, //手牌挂账
      };
      submitFoodOrder(requestData)
        .then((res) => {
          this.isSubmitFoodOrder = false
          this.$toast("提交成功");
          this.$router.go(-1);
          this.$router.back();
        })
        .catch(error => {
            this.isSubmitFoodOrder = false
           this.$toast("提交消费失败:"+error);
        });
    },

    handleBottomClick() {
      if (this.pageStatus === "qrcode") {
        this.createQrCode();
        return;
      }
      if (!this.handCode) {
        this.$toast("请输入手牌号");
        return;
      }
      this.createQrCode();
    },
    createQrCode() {
      if (!this.handCode) {
        this.$toast("请输入手牌号");
        return;
      }
       if (!this.vpnInfo.vpnId) {
        this.$toast("门店信息为空");
        return;
      }
      this.loading = true;
      this.clearTimers();
      getQrcode({
        TableCode: this.handCode,
        VpnId:this.vpnInfo.vpnId
      })
        .then((res) => {
          console.log("getQrcode===== "+JSON.stringify(res))
          this.qrCodeText = this.getQrCodeText(res);
          this.pageStatus = "qrcode";
          this.countDown = 60;
          this.startCountDown();
          this.startBindPolling();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getQrCodeText(res) {
      if (typeof res === "string") {
        return res;
      }
      const qrFields = [
        "QCode",
        "QrCode",
        "QRCode",
        "QrCodeText",
        "QrCodeParaText",
        "QRCodeConent",
        "Url",
        "url",
        "WechatPointUrl",
        "wechatpointurl",
      ];
      const qrText = qrFields.map((key) => res && res[key]).find(Boolean);
      if (qrText) {
        return qrText;
      }
      return JSON.stringify({
        action: "keyCodeBind",
        tableCode: this.handCode,
        time: Date.now(),
      });
    },
    startCountDown() {
      this.timer = setInterval(() => {
        if (this.countDown <= 1) {
          this.clearTimers();
          this.countDown = 0;
          return;
        }
        this.countDown -= 1;
      }, 1000);
    },
    startBindPolling() {
      const vpnCode =
        (this.vpnInfo.vpnInfo && this.vpnInfo.vpnInfo.code) ||
        this.vpnInfo.vpnInfo.code ||
        "";
      if (!vpnCode) {
        return;
      }
      this.pollTimer = setInterval(() => {
        isbindinginfo(vpnCode,this.tableCode)
          .then((res) => {
            if (typeof res === "string" || !res.TableCode) {
              return;
            }
            this.handCode = res.TableCode || this.handCode;
            this.showSuccess();
          })
          .catch(() => {});
      }, 2000);
    },
    showSuccess() {
      this.pageStatus = "success";
      this.clearTimers();
    },
    clearTimers() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.key-code-page {
  min-height: 100vh;
  background: #fff;
  box-sizing: border-box;
  padding-bottom: 94px;
  color: #333;
}

.key-code-content {
  box-sizing: border-box;
  padding: 34px 30px 0;
}

.page-head {
  h1 {
    margin: 0;
    line-height: 44px;
    font-size: 32px;
    font-weight: 500;
    color: #333;
  }

  p {
    margin-top: 30px;
    line-height: 32px;
    font-size: 22px;
    color: #a6a6a6;
  }
}

.step-bar {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin: 58px 42px 0;
}

.step-line {
  position: absolute;
  left: 20px;
  right: 20px;
  top: 20px;
  height: 5px;
  background: #edf4fb;
  border-radius: 5px;
  overflow: visible;

  .line-progress {
    position: absolute;
    left: 0;
    top: 0;
    width: 0;
    height: 5px;
    background: var(--tc);
    border-radius: 5px;
  }

  .line-dot {
    position: absolute;
    top: 0;
    width: 10px;
    height: 5px;
    border-radius: 4px;
    background: var(--tc);
    box-shadow: 20px 0 0 var(--tc), 40px 0 0 var(--tc);
  }

  .line-dot {
    left: 24%;
  }

  .line-dot-right {
    left: 72%;
  }
}

.step-current-1 .line-progress {
  width: 24%;
}

.step-current-2 .line-progress {
  width: 72%;
}

.step-current-3 .line-progress {
  width: 100%;
}

.step-item {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 112px;
  color: #d6deed;
  font-size: 20px;
  font-weight: 500;

  i {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: #edf4fb;
    color: #d6deed;
    font-size: 22px;
    font-style: normal;
  }

  span {
    margin-top: 16px;
    line-height: 28px;
  }

  &.active {
    color: var(--tc);

    i {
      background: var(--tc);
      color: #fff;
    }
  }
}

.form-state {
  margin-top: 78px;
}

.section-title {
  position: relative;
  display: inline-block;
  line-height: 34px;
  font-size: 24px;
  font-weight: 500;
  color: #333;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 116px;
    height: 10px;
    background: var(--tc);
    opacity: 0.28;
  }
}

.hand-input {
  display: block;
  width: 100%;
  height: 82px;
  margin-top: 44px;
  padding: 0 40px;
  border: 0;
  border-radius: 42px;
  outline: none;
  box-sizing: border-box;
  background: #f8f8f8;
  color: #333;
  font-size: 22px;

  &::placeholder {
    color: #888;
  }
}

.qr-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 96px;
}

.qr-box {
  width: 420px;
  height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-desc {
  margin-top: 42px;
  line-height: 28px;
  font-size: 20px;
  color: #999;
}

.expire-tips {
  margin-top: 22px;
  line-height: 30px;
  font-size: 20px;
  font-weight: 500;
  color: #ff4d4f;
}

.success-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 82px;
}

.success-icon {
  position: relative;
  width: 330px;
  height: 330px;
  border-radius: 50%;
  background: rgba(0, 205, 196, 0.12);

  &::before {
    content: "";
    position: absolute;
    inset: 44px;
    border-radius: 50%;
    background: rgba(0, 205, 196, 0.2);
  }

  &::after {
    content: "";
    position: absolute;
    inset: 88px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--tc), rgba(130, 239, 202, 0.72));
  }

  i {
    position: absolute;
    z-index: 1;
    left: 112px;
    top: 140px;
    width: 132px;
    height: 60px;
    border-left: 16px solid #fff;
    border-bottom: 16px solid #fff;
    border-radius: 6px;
    transform: rotate(-45deg);
  }
}

.success-subtitle {
  margin-top: 62px;
  line-height: 34px;
  font-size: 24px;
  color: #999;
}

.success-title {
  margin-top: 42px;
  line-height: 48px;
  font-size: 38px;
  font-weight: 600;
  color: var(--tc);
}

.bottom-btn {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 94px;
  border: 0;
  outline: none;
  background: var(--tc);
  color: #fff;
  font-size: 26px;
  font-weight: 400;

  &.disabled {
    opacity: 0.45;
  }
}

.waiter-order {
  min-height: 100vh;
  padding: 30px 30px 116px;
  box-sizing: border-box;
  color: #333;
  font-size: 26px;
}

.waiter-head {
  display: flex;
  align-items: baseline;
  line-height: 38px;

  strong { font-size: 30px; font-weight: 500; }
  span { margin-left: 8px; color: #aaa; font-size: 20px; }
}

.waiter-section {
  margin-top: 28px;

  h2 {
    position: relative;
    margin: 0 0 28px;
    padding-left: 20px;
    font-size: 27px;
    line-height: 32px;
    font-weight: 500;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 1px;
      width: 6px;
      height: 30px;
      background: var(--tc);
    }
  }
}

.bind-row {
  display: flex;
  gap: 14px;

  input {
    flex: 1;
    min-width: 0;
    height: 80px;
    padding: 0 40px;
    border: 0;
    border-radius: 42px;
    outline: none;
    box-sizing: border-box;
    background: #f7f7f7;
    font-size: 24px;
  }

  button {
    width: 142px;
    height: 80px;
    border: 0;
    border-radius: 42px;
    background: var(--tc);
    color: #fff;
    font-size: 25px;
  }
}

.goods-section { margin-top: 48px; }
.goods-section h2 { margin-bottom: 32px; }
.goods-table-head,
.goods-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 90px 126px 66px;
  align-items: center;
}

.goods-table-head {
  padding-bottom: 17px;
  color: #aaa;
  font-size: 24px;

  span:not(:first-child) { text-align: center; }
}

.goods-row {
  min-height: 76px;
  border-top: 1px solid #ddd;
  font-size: 21px;

  > span:nth-child(2) { text-align: center; }
}

.goods-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 10px;
}

.quantity-control {
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    padding: 0;
    border: 4px solid var(--tc);
    border-radius: 50%;
    background: #fff;
    color: var(--tc);
    font-size: 28px;
    line-height: 28px;

    &:disabled { border-color: #d4d8d8; color: #d4d8d8; }
  }

  span { min-width: 26px; text-align: center; }
}

.delete-btn {
  position: relative;
  width: 44px;
  height: 52px;
  margin: auto;
  border: 0;
  background: transparent;

  &::before {
    content: "";
    position: absolute;
    left: 5px;
    top: 10px;
    width: 30px;
    height: 3px;
    background: #999;
    box-shadow: 5px -7px 0 -1px #999;
  }

  i {
    position: absolute;
    left: 9px;
    top: 17px;
    width: 24px;
    height: 28px;
    border: 2px solid #999;
    border-top: 0;

    &::after { content: "Ⅱ"; color: #999; font-size: 18px; font-style: normal; }
  }
}

.goods-empty { padding: 28px 0; border-top: 1px solid #ddd; color: #aaa; text-align: center; }
.remark-section { position: relative; margin-top: 42px; }
.quick-remarks {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  padding-left: 10px;

  button {
    min-height: 74px;
    padding: 0 20px;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    background: #fff;
    color: #777;
    font-size: 23px;

    &.selected { border-color: var(--tc); color: var(--tc); background: rgba(0, 205, 196, .06); }
  }
}

.remark-section textarea {
  display: block;
  width: 100%;
  height: 155px;
  margin-top: 22px;
  padding: 18px 40px;
  border: 0;
  outline: none;
  resize: none;
  box-sizing: border-box;
  color: #555;
  font-size: 24px;
  line-height: 36px;
}

.remark-count { display: block; padding-right: 40px; color: #aaa; font-size: 22px; text-align: right; }
.waiter-status {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 94px;
  background: var(--tc);
  color: #fff;
  font-size: 27px;
  line-height: 94px;
  text-align: center;
}
.waiter-status-other {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 94px;
  background: #999;
  color: #fff;
  font-size: 27px;
  line-height: 94px;
  text-align: center;
}
</style>
